import React, { FC, useState, ReactNode } from 'react';
import { HiChevronUp, HiChevronDown } from 'react-icons/hi';

import cn from '@core/utils/classNames';

import styles from './SimpleCollapsible.module.css';

interface SimpleCollapsibleProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}

const SimpleCollapsible: FC<SimpleCollapsibleProps> = ({ title, children, defaultOpen = true, className = '' }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={cn(styles.container, className)}>
      <button type="button" onClick={() => setIsOpen(!isOpen)} className={styles.button}>
        <p className={styles.header}>{title}</p>
        {isOpen ? <HiChevronUp /> : <HiChevronDown />}
      </button>
      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default SimpleCollapsible;
